import { useEffect, useState } from 'react';

export default function SnowEffect() {
  const [snowflakes, setSnowflakes] = useState<any[]>([]);

  useEffect(() => {
    const createSnowflakes = () => {
      const flakes = [];
      const numberOfSnowflakes = 50;

      for (let i = 0; i < numberOfSnowflakes; i++) {
        flakes.push({
          id: i,
          left: Math.random() * 100,
          top: -(Math.random() * 100),
          animationDuration: Math.random() * 3 + 5,
          animationDelay: 0,
          fontSize: Math.random() * 10 + 10,
          opacity: Math.random() * 0.6 + 0.4,
        });
      }
      setSnowflakes(flakes);
    };

    createSnowflakes();
  }, []);

  return (
    <>
      <style>{`
        .snow-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 9999;
          overflow: hidden;
        }

        .snowflake {
          position: absolute;
          color: white;
          user-select: none;
          animation: snowfall linear infinite;
        }

        @keyframes snowfall {
          0% {
            transform: translateY(0vh) translateX(0);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) translateX(50px);
            opacity: 0.8;
          }
        }
      `}</style>
      <div className="snow-container">
        {snowflakes.map((flake) => (
          <div
            key={flake.id}
            className="snowflake"
            style={{
              left: `${flake.left}%`,
              top: `${flake.top}vh`,
              animationDuration: `${flake.animationDuration}s`,
              fontSize: `${flake.fontSize}px`,
              opacity: flake.opacity,
            }}
          >
            ❄
          </div>
        ))}
      </div>
    </>
  );
}
